import { InputType } from '@app/enums/shared/input-type';
import { Filters } from './filters';
import {
  MaterialInputTextField,
  MaterialInputSelectField,
  MaterialInputMultiselectField,
  MaterialInputCheckboxField,
} from './input-fields';
import { SearchMode } from '@app/enums/search-mode';

export type IncidentsFilters = Filters<{
  searchBy: MaterialInputTextField;
  searchIn: MaterialInputMultiselectField;
  countryCodes: MaterialInputMultiselectField;
  dateStart: MaterialInputTextField;
  dateEnd: MaterialInputTextField;
  motivation: MaterialInputMultiselectField;
  businessSector: MaterialInputMultiselectField;
  entitySize: MaterialInputMultiselectField;
  actorTypes: MaterialInputMultiselectField;
  revenueFrom: MaterialInputTextField;
  revenueTo: MaterialInputTextField;
  incidentDisabled: MaterialInputSelectField;
  incidentTypes: MaterialInputMultiselectField;
  dnbId: MaterialInputTextField;
  includeSubsidiaries: MaterialInputCheckboxField;
}>;

export const defaultIncidentsSearchFilters: IncidentsFilters = {
  searchBy: {
    type: InputType.Text,
    value: '',
  },
  searchIn: {
    type: InputType.Multiselect,
    value: [SearchMode.EntityNameAndTitle],
  },
  countryCodes: {
    type: InputType.Multiselect,
    value: [],
  },
  dateStart: {
    type: InputType.Text,
    value: '',
  },
  dateEnd: {
    type: InputType.Text,
    value: '',
  },
  motivation: {
    type: InputType.Multiselect,
    value: [],
  },
  businessSector: {
    type: InputType.Multiselect,
    value: [],
  },
  entitySize: {
    type: InputType.Multiselect,
    value: [],
  },
  actorTypes: {
    type: InputType.Multiselect,
    value: [],
  },
  revenueFrom: {
    type: InputType.Text,
    value: '',
  },
  revenueTo: {
    type: InputType.Text,
    value: '',
  },
  incidentDisabled: {
    type: InputType.Select,
    value: '',
  },
  incidentTypes: {
    type: InputType.Multiselect,
    value: [],
  },
  dnbId: {
    type: InputType.Text,
    value: '',
  },
  includeSubsidiaries: {
    type: InputType.Checkbox,
    value: false,
  },
};
